var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeflon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "236.000000pt",
    height: "56.000000pt",
    viewBox: "0 0 236.000000 56.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,56.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M417 216 c-3 -8 -2 -18 3 -21 13 -8 24 15 12 27 -6 6 -11 4 -15 -6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690 180 c0 -15 7 -20 25 -20 25 0 25 -1 25 -80 0 -79 0 -80 25 -80 25 0 25 1 25 80 0 79 0 80 25 80 18 0 25 5 25 20 0 18 -7 20 -75 20 -68 0 -75 -2 -75 -20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M867 194 c-4 -4 -7 -49 -7 -101 l0 -93 70 0 c63 0 70 2 70 20 0 17 -7 20 -45 20 -38 0 -45 3 -45 20 0 17 7 20 40 20 33 0 40 3 40 20 0 17 -7 20 -40 20 -33 0 -40 3 -40 20 0 17 7 20 46 20 38 0 45 3 42 18 -3 13 -15 18 -64 20 -33 2 -63 0 -67 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1040 100 c0 -92 1 -100 19 -100 16 0 20 8 23 37 3 37 4 38 46 41 28 2 42 8 42 17 0 9 -14 15 -42 17 -35 2 -43 7 -43 23 0 16 8 21 43 23 34 3 42 7 42 23 0 17 -7 19 -65 19 l-65 0 0 -100z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1217 194 c-4 -4 -7 -50 -7 -101 l0 -94 62 3 c50 2 63 7 66 20 3 13 -6 17 -40 20 l-43 3 -1 75 c-1 56 -5 76 -16 78 -8 1 -17 0 -21 -4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1423 193 c-31 -6 -73 -59 -73 -93 0 -40 43 -88 86 -96 67 -12 124 30 124 94 0 46 -16 71 -55 88 -35 14 -42 15 -82 7z m77 -53 c27 -27 26 -65 -2 -84 -63 -45 -134 18 -87 77 25 32 61 35 89 7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1597 193 c-4 -3 -7 -48 -7 -100 l0 -93 26 0 c25 0 26 1 22 65 -1 36 0 65 4 65 3 0 23 -29 44 -65 33 -55 42 -65 66 -65 l28 0 0 100 c0 93 -1 100 -20 100 -18 0 -20 -7 -20 -67 -1 -66 -1 -67 -18 -47 -9 12 -29 42 -44 68 -20 34 -34 46 -51 46 -13 0 -27 -3 -30 -7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1830 196 c-6 -66 1 -191 9 -194 7 -2 11 15 11 48 l0 51 52 -3 52 -3 0 -44 c1 -27 6 -46 14 -49 10 -3 12 17 10 92 -2 58 -7 95 -13 94 -5 -2 -10 -18 -10 -36 l0 -32 -52 0 -53 0 0 34 c0 19 -4 38 -10 41 -5 3 -10 4 -10 1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2030 121 c0 -74 2 -81 26 -100 33 -26 65 -27 95 -2 21 17 24 28 24 93 0 91 -16 97 -18 7 -2 -72 -16 -99 -53 -99 -41 0 -54 25 -54 106 0 43 -4 74 -10 74 -6 0 -10 -33 -10 -79z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2220 101 l0 -101 41 0 c83 0 123 46 79 90 -19 19 -19 22 -5 36 18 19 19 25 2 48 -9 12 -31 20 -65 24 l-52 5 0 -102z m88 70 c8 -5 12 -17 10 -27 -2 -14 -13 -20 -41 -22 -35 -3 -37 -2 -37 27 0 27 3 31 28 31 15 0 33 -4 40 -9z m3 -81 c23 -13 25 -55 3 -64 -9 -3 -29 -6 -45 -6 -26 0 -29 3 -29 33 0 19 3 37 7 40 10 10 42 8 64 -3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeflon);
export default __webpack_public_path__ + "static/media/teflon.4d44a07f7ce4b26d281467f6e5a1655d.svg";
export { ForwardRef as ReactComponent };